// extracted by mini-css-extract-plugin
export default {"root":"TeamAmPortrait_root__VFbmU","image":"TeamAmPortrait_image__2ZOvI","placeholder":"TeamAmPortrait_placeholder__HMs7v"};